import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from '../../../services/common.service';
import { ApiService } from '../../../services/api.service';
import { DatatableComponent } from '@siemens/ngx-datatable';
import { Location } from '@angular/common';

import { Page } from 'src/app/models/page.model';
import { Subscription, Subject } from 'rxjs';

@Component({
  selector: 'app-standarddocumentdetails',
  templateUrl: './standarddocumentdetails.page.html',
  styleUrls: ['./standarddocumentdetails.page.scss'],
})
export class StandarddocumentdetailsPage implements OnInit {
  @ViewChild('uploader', { static: false }) uploader: any;
  @ViewChild('table') table: DatatableComponent;
  // @ViewChild('selectie', { static: false }) selectie: ElementRef;
  @ViewChild('searchFocus', { static: false }) ionInput: { setFocus: () => void; };
  page = new Page();
  standardForm: FormGroup;
  submitted = false;
  standardId: string;
  standard: any = {};
  standardDocument: any = {};
  tempStandardDocumnet: any = {}
  showPage: boolean = false;
  detailSave: boolean = false;
  locale: any;
  searchText: any = '';
  tempLocale: any;
  templateLocale: any = [];
  TemplateType: any = [];
  rows: any = [];
  body: any;

  preventClick: boolean = true;
  searchSubscription: Subscription;
  toggleSubscription: Subscription;
  resizeSubscription: Subscription;
  searchEvent: Subject<any>;
  columnsWidth: any = [];
  test: any;
  newPage: boolean = false;
  showSearchContainer: boolean = false;
  showSearch: boolean = false;


  docxName: any;
  fileUpload: any;
  fileValidation: boolean = false;
  breadcrumb: any = {
    standardName: null
  }
  AllLocales: any = [];
  archiveIcon: string = "eye-off";
  allVersion: string = "";
  showArchive: number = 0;

  domains: any = [];
  subscriptionList: any = [];
  constructor(private router: Router, private route: ActivatedRoute,
    private formBuilder: FormBuilder, private _apiService: ApiService, public _commonService: CommonService, private location: Location) {
    this.page.pageNumber = 0;
    this.page.size = 20;
    this.searchEvent = this._commonService.searchTextValue;
  }

  ngOnInit() {
    this.standardForm = this.formBuilder.group({
      Name: ['', Validators.required],
      Remarks: [''],
      Domain: [''],
      Subscription: [''],
      DocumentFileNaame: ['', Validators.required],
      AllSubscriptions:[false]
    });
  }
  ionViewWillEnter() {
    this.archiveIcon = "eye-off";
    this.showSearchContainer = false;
  }
  ngAfterViewInit() {
    //   $('.myModal').select({
    //     dropdownParent: $('.test')
    // });

  }

  autofocusInput() {
    this.ionInput.setFocus();
    // setTimeout(() => {
    //   this.test.nativeElement.firstChild['autofocus'] = 'true';
    // }, 100);
  }

  ionViewDidLeave() {
    this.showPage = false;
    this.newPage = false;
    // this.AllLocales = [];
  }
  ionViewDidEnter() {
    this.standardId = this.route.snapshot.paramMap.get('id');
    // this.locale = Number((localStorage.locale && localStorage.locale != '') ? localStorage.locale : 1043);
    // this.tempLocale = this.locale;
    this.detailSave = false;
    if (this.standardId == '0') {
      this.standardId = null;
      this.newPage = true;
      // this.getLocales();
      this.getSubsriptionSetting();
      this.getDomains();
    }
    if (this.standardId) {
      this.getStandardDocumentDetails();
      // this.standardForm.get('DocumentFileNaame').clearValidators();
      // this.standardForm.get("DocumentFileNaame").setErrors(null);
      // this.standardForm.get('DocumentFileNaame').updateValueAndValidity();
    }

  }



  // async getLocales() {
  //   try {
  //     if (localStorage.domainLocales) {
  //       this.AllLocales = JSON.parse(localStorage.domainLocales);
  //       for (let i = 0; i < this.AllLocales.length; i++) {
  //         if (this.AllLocales[i].LocaleIconUrl == 'flag-icon-nl') {
  //           this.AllLocales[i].Icon = 'assets/flags/1x1/nl.svg'
  //         }
  //         if (this.AllLocales[i].LocaleIconUrl == 'flag-icon-gb') {
  //           this.AllLocales[i].Icon = 'assets/flags/1x1/gb.svg'
  //         }
  //       }
  //     } else {
  //       let localeData = await this._apiService.getDomainLocales('', 1, 0);
  //       this.AllLocales = JSON.parse(localStorage.domainLocales);
  //       localStorage.domainLocales = JSON.stringify(localeData.body);
  //       for (let i = 0; i < this.AllLocales.length; i++) {
  //         if (this.AllLocales[i].LocaleIconUrl == 'flag-icon-nl') {
  //           this.AllLocales[i].Icon = 'assets/flags/1x1/nl.svg'
  //         }
  //         if (this.AllLocales[i].LocaleIconUrl == 'flag-icon-gb') {
  //           this.AllLocales[i].Icon = 'assets/flags/1x1/gb.svg'
  //         }
  //       }
  //     }
  //     if (this.standardId == null) {
  //       this.showPage = true;
  //     }
  //   } catch (error) {
  //     this._commonService.log(error, this._commonService.ERROR);
  //   }
  // }

  async getDomains() {
    try {
      if (localStorage.domainList) {
        this.domains = JSON.parse(localStorage.domainList);
      } else {
        let domainData = await this._apiService.getDomains('', '', '', 1, 0, true);
        this.domains = domainData.body;
        localStorage.domainList = this.domains;
        localStorage.setItem('domainList', this.domains ? JSON.stringify(this.domains) : null);
      }
      if (this.standardId == null) {
        this.showPage = true;
      }
    } catch (error) {
      this._commonService.log(error, this._commonService.ERROR);
    }
  }
  async getSubsriptionSetting() {
    try {
      let res = await this._apiService.getSubsriptionSettings('',localStorage.domainId,1,'', '', '', 1, 0);
      this.subscriptionList = [...res.body];

    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error.error, this._commonService.ERROR);
    }
  }

  onChangeBreadcrumb() {
    this.breadcrumb.standardName = this.standardForm.value.Name;
  }

  async onSort(event) {
  }
  async getStandardDocumentDetails() {
    try {
      this._commonService.presentLoading();
      let res = await this._apiService.getStandardDocumentDetail(this.standardId);
      this.standardDocument = res.body;
      this.tempStandardDocumnet = res.body
      // await this.getLocales();
      await this.getSubsriptionSetting();
      await this.getDomains();
      this.breadcrumb.standardName = this.standardDocument.Name;
      this.standardDocument.DocumentSubscription = [];
      this.standardDocument.Domains = [];
      if (this.standardDocument.StandardDocumentSubscriptions) {
        this.standardDocument.StandardDocumentSubscriptions.forEach(item => {
          this.standardDocument.DocumentSubscription.push(item.DomainSubscriptionId);
        });

      }
      if (this.standardDocument.StandardDocumentDomains) {
        this.standardDocument.StandardDocumentDomains.forEach(item => {
          this.standardDocument.Domains.push(item.DomainId);
        });

      }
      console.log(this.standardDocument.DocumentSubscription, this.standardDocument.Domains)
      this.standardForm.patchValue({
        Name: this.standardDocument.Name,
        Remarks: this.standardDocument.Remarks,
        Domain: this.standardDocument.Domains,
        Subscription: this.standardDocument.DocumentSubscription,
        DocumentFileNaame: this.standardDocument.DocumentName,
        AllSubscriptions: this.tempStandardDocumnet.AllSubscriptions == "1"? true:false
      })
      this._commonService.dismiss();
      this.standardForm.updateValueAndValidity();
      this.showPage = true;


    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  get f() { return this.standardForm.controls; }

  async onSubmit() {
    this.submitted = true;
    if (this.standardId) {
      this.standardForm.get('DocumentFileNaame').clearValidators();
      this.standardForm.get("DocumentFileNaame").setErrors(null);
      this.standardForm.get('DocumentFileNaame').updateValueAndValidity();
    }
    if (this.standardForm.invalid) {
      this._commonService.scrollToError();
      return;
    }
    this._commonService.presentLoading();
    try {
      let formData = new FormData();
      formData.append('file', this.fileUpload);
      formData.append('DocumentName', this.docxName ? this.docxName : this.standardForm.value.DocumentFileNaame);
      formData.append('Name', this.standardForm.value.Name);
      formData.append('AllSubscriptions', this.standardForm.value.AllSubscriptions ? "1" : "0");
      if(this.standardForm.value.Subscription) {
        formData.append('StandardDocumentSubscriptions', this.standardForm.value.Subscription);
      }
      if(this.standardForm.value.Domain) {
        formData.append('StandardDocumentDomains', this.standardForm.value.Domain);
      }
      if(this.standardForm.value.Remarks) {
        formData.append('Remarks', this.standardForm.value.Remarks);
      }

      if (this.standardId) {
        formData.append('StandardDocumentId', this.standardId);
      }

      let res = await this._apiService.postStandardDocument(formData);
      this._commonService.dismiss();
      if (res && res.body.id) {
        this.standardId = res.body.id;
        this.newPage = false;
        this.location.replaceState('maintenance/standarddocuments/' + this.standardId);
      }
      this._commonService.showToast(this._commonService.getLocalTranslation('label-recordSaved'));


      this.breadcrumb.standardName = this.standardForm.value.Name ? this.standardForm.value.Name : "";
      this._commonService.log(this.standardId, this._commonService.LOG);
      this._commonService.dismiss();
      this._commonService.showToast(this._commonService.getLocalTranslation('label-recordSaved'));
      this.submitted = false;
    }
    catch (error) {
      if(error.status >= 500 && error.status < 600){
        this.breadcrumb.standardName = this.tempStandardDocumnet.Name;

        this.standardForm.patchValue({
          Name: this.tempStandardDocumnet.Name,
          Remarks: this.tempStandardDocumnet.Remarks,
          Domain: this.tempStandardDocumnet.Domains,
          Subscription: this.tempStandardDocumnet.DocumentSubscription,
          DocumentFileNaame: this.tempStandardDocumnet.DocumentName,
          AllSubscriptions: this.tempStandardDocumnet.AllSubscriptions == "1"? true:false
        })

      }
      this._commonService.dismiss();

      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  delete() {
    this._commonService.presentAlertConfirm()
      .then(async (res) => {
        try {
          this._commonService.presentLoading();
          await this._apiService.deleteStandardDocuments(this.standardId);
          this._commonService.dismiss();
          this._commonService.log(res, this._commonService.LOG);
          this.goBack();
        } catch (error) {
          this._commonService.dismiss();
          this._commonService.log(error, this._commonService.ERROR);
        }
      })
      .catch((err) => {
        this._commonService.log(err, this._commonService.LOG);
      })
  }
  async onSelectFile(files: any) {
    let items: any = [];
    try {
      if (files.length > 0 && files.length < 50) {

        let fileName = files[0].name;
        this.fileUpload = files[0];
        let ext = null;
        this.docxName = fileName;
        this.standardForm.patchValue({
          DocumentFileNaame: fileName
        });
        this._commonService.dismiss();
      } else if (files.length > 50) {
        this._commonService.dismiss();
        this._commonService.presentAlert("", this._commonService.getLocalTranslation('label-fileNumberExceeded'));
      }
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
    this.uploader.nativeElement.value = null;
  }
  uploadTemplate() {
    this.uploader.nativeElement.click();
    window.addEventListener('focus', this.checkvalidation, false);
  }

  checkvalidation = () => {
    setTimeout(() => {
      this.fileValidation = true;
    }, 100);
    window.removeEventListener('focus', this.checkvalidation, false);
  }
  goBack() {
    this.location.back();
  }
  onActionChange(obj) {

    switch (obj.Action) {
      case "save":
        this.onSubmit();
        break;
      case "delete":
        this.delete();
        break;
      case "backToList":
        this.goBack();
        break;
      case "backToMain":
        this.router.navigate(['maintenance'], { replaceUrl: true })
        break;
      case "back":
        this.goBack();
        break;


    }

  }

}
